module.exports = __webpack_public_path__ + "img/bg@2x.b3b1af7c.png";